// src/theme/themeConfig.js
const themeConfig = {
  token: {
    // Primary Purple Colors
    colorPrimary: "#7C3AED", // Vibrant purple as primary color
    colorPrimaryBg: "#F5F3FF", // Light purple background
    colorPrimaryBgHover: "#EDE9FE", // Hover state
    colorPrimaryBorder: "#C4B5FD", // Border color
    colorPrimaryHover: "#8B5CF6", // Hover state for primary elements
    colorPrimaryActive: "#6D28D9", // Active/pressed state

    // Status Colors (with purple undertones)
    colorSuccess: "#059669", // Success green
    colorWarning: "#D97706", // Warning orange
    colorError: "#DC2626", // Error red
    colorInfo: "#7C3AED", // Info using primary purple

    // Neutral Colors
    colorText: "#1F2937", // Text color
    colorTextSecondary: "#4B5563", // Secondary text
    colorTextDescription: "#6B7280", // Description text
    colorBgContainer: "#FFFFFF", // Background of containers
    colorBorder: "#E5E7EB", // Border color
    colorBgLayout: "#faf5ff", // Layout background

    // Font Settings
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,

    // Border & Radius
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 4,
    borderWidth: 1,

    // Animation
    motionUnit: 0.1,
    motionBase: 0,

    // Component Base Tokens
    controlHeight: 40,
    controlHeightSM: 32,
    controlHeightLG: 48,
  },

  components: {
    Button: {
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      paddingContentHorizontal: 24,
      paddingContentVertical: 8,
      borderRadius: 8,
    },

    Card: {
      padding: 24,
      borderRadiusLG: 12,
      boxShadow:
        "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    },

    Input: {
      controlHeight: 40,
      borderRadius: 8,
      paddingInline: 16,
    },

    Select: {
      controlHeight: 40,
      borderRadius: 8,
    },

    Menu: {
      itemBorderRadius: 8,
      itemMarginInline: 8,
      itemPaddingInline: 16,
    },

    Table: {
      borderRadius: 12,
      headerBg: "#F5F3FF",
    },
  },
};

export default themeConfig;
